import React, { FC } from 'react';
import ReactDOM from 'react-dom';

import styles from './portal.module.scss';

interface IProps {
  children: React.ReactNode;
  className?: string;
  element?: string;
}

const Portal: FC<IProps> = ({
  children,
  className = styles.portal,
  element = 'div'
}) => {
  const [container] = React.useState(() => {
    const el = document.createElement(element);
    el.classList.add(className);
    return el;
  });

  React.useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return ReactDOM.createPortal(children, container);
};

export default Portal;
